import { withStyles } from '@material-ui/styles';
import { flowRight } from 'lodash';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import checkNumberData from '../../../utils/checkNumberData';
import { createValueLabel, mapValue } from '../actions/dataActions';
import styles from '../styles/generalData';
import CustomTitle from './CustomTitle';
import Optional from '../../../utils/optional';
import { formatDateForDisplay } from '../../../utils/formatDate';

const CarrierOverview = ({
  classes,
  carrierData = {},
  fromRightPanel = false,
  rightPanelData = {}
}) => {
  const { isDataExist, data } = useMemo(() => {
    return checkNumberData({
      numberData: carrierData,
      rightPanelData,
      fromRightPanel
    });
  }, [carrierData, rightPanelData, fromRightPanel]);

  return (
    <div className={classes.root}>
      <CustomTitle
        title="OVERVIEW"
        isDataExist={isDataExist}
        isDefaultOpen={true}
      >
        {isDataExist && (
          <div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FAFAFA' }}
            >
              <div className={classes.dataKey}>Product name</div>
              <div>{Optional(data?.productName).or('')}</div>
            </div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FFF' }}
            >
              <div className={classes.dataKey}>Phone number</div>
              <div>{Optional(data?.phoneNumber).or('')}</div>
            </div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FAFAFA' }}
            >
              <div className={classes.dataKey}>ICCID</div>
              <div>{Optional(data?.ICCID).or('')}</div>
            </div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FFF' }}
            >
              <div className={classes.dataKey}>Status</div>
              <div>{Optional(data?.productStatus).or('')}</div>
            </div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FAFAFA' }}
            >
              <div className={classes.dataKey}>SIM type</div>
              <div>{Optional(data?.simType).or('')}</div>
            </div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FFF' }}
            >
              <div className={classes.dataKey}>Start date</div>
              <div>
                {Optional(data?.startDate)
                  .map(date => formatDateForDisplay(date))
                  .or('')}
              </div>
            </div>
            <div
              className={classes.dataContainer}
              style={{ backgroundColor: '#FAFAFA' }}
            >
              <div className={classes.dataKey}>Product ID</div>
              <div>{Optional(data?.productId).or('')}</div>
            </div>
          </div>
        )}
      </CustomTitle>
    </div>
  );
};

const mapStatesToProps = ({ checkNumber, rightPanel, auth }) => {
  return {
    carrierData: checkNumber?.carrierData?.overview,
    rightPanelData: rightPanel?.number?.carrierData?.overview,
    lang: auth.lang
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(CarrierOverview);
